<div *ngIf="jobAvailable" class="container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row my-3">
        <div class="col-sm-12 text-center font-weight-bold">
            তফসিল ১
        </div>
    </div>
    <div class="row my-3 font-weight-bold">
        <div class="col-sm-12 text-center">
            চাকরি হইতে আয় থাকিলে নিম্নোক্ত তফসিলটি পূরণ করিতে হইবে
        </div> 
        <div class="col-sm-12 text-center">
            ক. সরকারি বেতন আদেশভুক্ত কর্মচারী করদাতাদের জন্য এই অংশটি প্রযোজ্য
        </div>    
    </div>
    <div class="row my-3">
        <div class="col-sm-5">করদাতার নাম: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            টি আইএন: 
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div class="my-5 job-table">
        <div class="row bt bb" style="height:50px">
            <div class="col-sm-5 text-center bl br">বিবরণসমূহ</div>
            <div class="col-sm-2 text-center br">আয়ের পরিমাণ</div>
            <div class="col-sm-3 text-center br">কর অব্যাহতি প্রাপ্ত আয়</div>
            <div class="col-sm-2 text-center br">নিট করযোগ্য আয়</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">মূল বেতন</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BASIC_PAY?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_BASIC_PAY?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BASIC_PAY?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">বকেয়া বেতন (যা পূর্বে করযোগ্য আয়ের অন্তর্ভুক্ত হয় নাই)</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_ARREAR_PAY?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_ARREAR_PAY?.exempted : '' )| formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_ARREAR_PAY?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">বিশেষ বেতন</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SPECIAL_PAY?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_SPECIAL_PAY?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SPECIAL_PAY?.taxable : '')| formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">বাড়িভাড়া ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HOUSE_RENT_ALW?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_HOUSE_RENT_ALW?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HOUSE_RENT_ALW?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">চিকিৎসা ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_MEDICAL_ALW?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_MEDICAL_ALW?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_MEDICAL_ALW?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">যাতায়াত ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_CONVEYANCE_ALW?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_CONVEYANCE_ALW?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_CONVEYANCE_ALW?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">উৎসব ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_FESTIVAL_BONUS?.gross : '') | formatNumberReturnView}} </div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_FESTIVAL_BONUS?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_FESTIVAL_BONUS?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">সহায়ক কর্মীর জন্য প্রদত্ত ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_ALLOWANCE_SUPPORT_STAFF?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_ALLOWANCE_SUPPORT_STAFF?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_ALLOWANCE_SUPPORT_STAFF?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">ছুটি ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_REST_RECREATION_ALW?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_REST_RECREATION_ALW?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_REST_RECREATION_ALW?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">সম্মানী/পুরস্কার</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HONORARIUM_REWARD_FEE?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_HONORARIUM_REWARD_FEE?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HONORARIUM_REWARD_FEE?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">ওভার টাইম ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OVERTIME_ALW?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_OVERTIME_ALW?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OVERTIME_ALW?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">বৈশাখী ভাতা</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BANGLA_NEW_YEAR_ALW?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_BANGLA_NEW_YEAR_ALW?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BANGLA_NEW_YEAR_ALW?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">ভবিষ্য তহবিলে অর্জিত সুদ</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GPF_INTEREST?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_GPF_INTEREST?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GPF_INTEREST?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">লাম্পগ্র্যান্ট</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_LUMPGRANT_LEAVE_ENCASH?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_LUMPGRANT_LEAVE_ENCASH?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_LUMPGRANT_LEAVE_ENCASH?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">গ্র্যাচুইটি</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GRATUITY?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_GRATUITY?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GRATUITY?.taxable  : '')| formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">অন্যান্য, যদি থাকে (বিবরণ দিন)</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OTHER?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_OTHER?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OTHER?.taxable : '') | formatNumberReturnView}}</div>
        </div>
        <div class="row bb">
            <div class="col-sm-5 bl br">মোট</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SUM?.gross : '') | formatNumberReturnView}}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_SUM?.exempted : '') | formatNumberReturnView}}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SUM?.taxable : '') | formatNumberReturnView}}</div>
        </div>
    </div>

    <!-- non govt employees -->
    <div style="page-break-inside: avoid;">
        <div class="row my-3">
            <div class="col-sm-12 text-center font-weight-bold">
                খ. সরকারি বেতন আদেশভুক্ত কর্মচারী ব্যতীত অন্যান্য চাকরিজীবী করদাতার জন্য এই অংশটি প্রযোজ্য
            </div>           
        </div>
    
        <div class="my-3">
            <div class="row bt bb">
                <div class="col-sm-6 text-center bl br pt-1 pb-3">বিবরণ</div>
                <div class="col-sm-3 text-center br pt-1 pb-3">আয়ের পরিমাণ</div>
                <div class="col-sm-3 text-center br pt-1 pb-3">আয়ের পরিমাণ</div>            
            </div>
            <div class="row">
                <div class="col-sm-9 job-table">
                    <div class="row bb">
                        <div class="col-sm-8 bl br">বেতন</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_BASIC_PAY?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">ভাতাসমূহ</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_ALLOWANCES.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">অগ্রিম/ বকেয়া বেতন</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_ARREAR_PAY?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">আনুতোষিক, অ্যানুইটি, পেনশন বা ইহাদের সম্পূরক</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_GRATUITY_AND_IS_PENSION?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">পারকুইজিট</div>
                        <div class="col-sm-4 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">বেতন বা মজুরির পরিবর্তে প্রাপ্তি অথবা অতিরিক্ত প্রাপ্তি</div>
                        <div class="col-sm-4 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">কর্মচারী শেয়ার স্কিম হইতে অর্জিত আয়</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_EMP_SHARE_RECEIVED_AND_SELL?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">আবাসন সুবিধা</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_EMP_ACCOMMODATION_FACILITY?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">মোটরগাড়ি সুবিধা</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_MOTOR_CAR_FACILITY?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">নিয়োগকর্তা কর্তৃক প্রদত্ত অন্যকোন সুবিধা</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_OTHER_NON_CASH_BENEFITS?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">স্বীকৃত ভবিষ্য তহবিলে নিয়োগকর্তার প্রদত্ত চাঁদা</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_EMP_CONTRIBUTION_RPF?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">অন্যান্য, যদি থাকে (বিবরণ দিন)</div>
                        <div class="col-sm-4 br">{{(nongovtSum ? nongovtSalary?.IS_OTHER?.gross : '') | formatNumberReturnView}}</div>
                    </div>
                </div>            
                <div class="col-sm-3 bb br text-center py-2">
                    {{(nongovtSum ? nongovtSalary?.IS_SUM?.gross : '') | formatNumberReturnView}}
                </div>
            </div>
            <div class="row bb">
                <div class="col-sm-9 bl br py-2">মোট প্রাপ্ত বেতন</div>
                <div class="col-sm-3 br py-2">{{(nongovtSum ? nongovtSalary?.IS_SUM?.gross : '') | formatNumberReturnView}}</div>
            </div>
            <div class="row bb">
                <div class="col-sm-9 bl br py-2">অব্যাহতি প্রাপ্ত অংশ (আয়কর আইন, ২০২৩ এর ৬ষ্ঠ তফসিলের অংশ ১ অনুযায়ী)</div>
                <div class="col-sm-3 br py-2">{{(nongovtSum ? nongovtSalary?.IS_SUM?.exempted : '') | formatNumberReturnView}}</div>
            </div>
            <div class="row bb">
                <div class="col-sm-9 bl br py-2">চাকরি হইতে মোট আয়</div>
                <div class="col-sm-3 br py-2">{{(nongovtSum ? nongovtSalary?.IS_SUM?.taxable : '') | formatNumberReturnView}}</div>
            </div>
        </div>
    </div>
</div>